'use strict';

/**
 * Interpreta fecha + hora de un CSV de importación de tareas.
 * Acepta fecha AAAA-MM-DD o D/M/AAAA (también - o .) y hora HH:mm o HH:mm:ss.
 * Devuelve Date local o null si el valor no es válido.
 */
function parseImportDateTime(day, hour) {
    if (day == null || hour == null) {
        return null;
    }
    const dayStr = String(day).trim();
    const hourStr = String(hour).trim();
    if (dayStr === '' || hourStr === '') {
        return null;
    }

    let year;
    let month;
    let date;
    const isoMatch = dayStr.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    const dmyMatch = dayStr.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (isoMatch) {
        year = parseInt(isoMatch[1], 10);
        month = parseInt(isoMatch[2], 10);
        date = parseInt(isoMatch[3], 10);
    } else if (dmyMatch) {
        date = parseInt(dmyMatch[1], 10);
        month = parseInt(dmyMatch[2], 10);
        year = parseInt(dmyMatch[3], 10);
    } else {
        return null;
    }

    const timeMatch = hourStr.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (!timeMatch) {
        return null;
    }
    const hours = parseInt(timeMatch[1], 10);
    const minutes = parseInt(timeMatch[2], 10);
    const seconds = parseInt(timeMatch[3] || '0', 10);

    if (month < 1 || month > 12 || date < 1 || date > 31 || hours > 23 || minutes > 59 || seconds > 59) {
        return null;
    }

    const result = new Date(year, month - 1, date, hours, minutes, seconds);
    if (
        isNaN(result.getTime()) ||
        result.getFullYear() !== year ||
        result.getMonth() !== month - 1 ||
        result.getDate() !== date
    ) {
        return null;
    }
    return result;
}

parseImportDateTime.isValid = function (value) {
    return value instanceof Date && !isNaN(value.getTime());
};

module.exports = parseImportDateTime;
